import Web3 from 'web3'
import BigNumber from 'bignumber.js'
import util from 'util'

import { isAppSupportedNetworkId } from '_src/utils/chain'
import { setIsSupportNetworkAction } from '_src/store/global/actions'
import { defaultChain } from '_src/utils/chain/chainConfUtil'

import { publicSelectChain } from '_src/components/SelectChain'
import store from '_src/store'

export function initWeb3(provider) {
  const web3 = new Web3(provider)

  web3.eth.extend({
    methods: [
      {
        name: 'chainId',
        call: 'eth_chainId',
        outputFormatter: web3.utils.numberToHex,
      },
    ],
  })

  return web3
}

export function createSendRpc(currentProvider) {
  return util.promisify(currentProvider.send).bind(currentProvider)
}

export function transformNetworkId(networkId) {
  // 只要10进制
  if (networkId) {
    const id = Web3.utils.isHexStrict(networkId) ? Web3.utils.hexToNumber(networkId) : networkId
    return id
  }

  return networkId
}

export function transformChainId(chainId) {
  // 只要10进制
  if (chainId) {
    const id = Web3.utils.isHexStrict(chainId) ? chainId : Web3.utils.numberToHex(chainId)
    return id
  }

  return chainId
}

export function isEqualAddress(from = '', to = '') {
  if (from && to) {
    return new BigNumber(from.toLowerCase()).eq(new BigNumber(to.toLowerCase()))
  }
  return false
}

export async function isNeedSwitchNetwork(switchNetworkId = '') {
  const { networkId = '', chainId = '' } = defaultChain()

  const { wallet, global } = store.getState()
  const { web3 = '' } = wallet

  if (!web3) {
    return new Promise((resolve, reject) => {
      reject(false)
    })
  }

  const web3networkId = await web3.eth.net.getId()

  return new Promise((resolve) => {
    // 平台支持的链
    if (isAppSupportedNetworkId(web3networkId)) {
      if (global.networkId == (switchNetworkId || networkId)) {
        // 不用切链
        resolve(true)
      } else {
        // 切链
        const params = {
          show: true,
          networkId: switchNetworkId,
          chainId: web3.utils.numberToHex(switchNetworkId),
        }
        store.dispatch(setIsSupportNetworkAction(params))
      }
    } else {
      // 平台不支持的链 切换成默认的主链AAC
      const params = {
        show: true,
        networkId,
        chainId,
      }
      store.dispatch(setIsSupportNetworkAction(params))
    }
  })
}

export async function switchMainNetwork() {
  try {
    const { chainId = '' } = defaultChain()
    const { global } = store.getState()

    if (chainId != global.chainId) {
      const res = await publicSelectChain(chainId).catch((error) => {
        console.log(error)
        return new Promise((resolve, reject) => {
          reject(false)
        })
      })

      if (res) {
        return new Promise((resolve) => {
          resolve(true)
        })
      }
    } else {
      return new Promise((resolve) => {
        resolve(true)
      })
    }
  } catch (error) {
    console.log(error)
    return new Promise((resolve, reject) => {
      reject(false)
    })
  }
}
